function initDynamicHeroSection(section) {
  if (section.dataset.initialized) return;
  section.dataset.initialized = 'true';

  const slides = section.querySelectorAll('.dynamic-hero__slide');
  const dots = section.querySelectorAll('.dynamic-hero__dot');
  const bgs = section.querySelectorAll('.dynamic-hero__bg');
  const prevBtn = section.querySelector('.dynamic-hero__nav-btn.prev');
  const nextBtn = section.querySelector('.dynamic-hero__nav-btn.next');

  if (!slides.length) return;

  let currentIndex = 0;
  let autoplayInterval;

  slides.forEach((slide, index) => {
    if (slide.classList.contains('is-active')) {
      currentIndex = index;
    }
  });

  const updateCarousel = (index) => {
    // Remove active classes
    slides.forEach(slide => slide.classList.remove('is-active'));
    dots.forEach(dot => dot.classList.remove('is-active'));
    bgs.forEach(bg => bg.classList.remove('is-active'));

    // Add active class to current
    if (slides[index]) slides[index].classList.add('is-active');
    if (dots[index]) dots[index].classList.add('is-active');
    if (bgs[index]) bgs[index].classList.add('is-active');

    currentIndex = index;
  };

  const nextSlide = () => {
    let newIndex = currentIndex + 1;
    if (newIndex >= slides.length) newIndex = 0;
    updateCarousel(newIndex);
  };

  const prevSlide = () => {
    let newIndex = currentIndex - 1;
    if (newIndex < 0) newIndex = slides.length - 1;
    updateCarousel(newIndex);
  };

  const startAutoplay = () => {
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, 3000);
  };

  const stopAutoplay = () => {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
    }
  };

  const resetAutoplay = () => {
    startAutoplay();
  };

  // Ensure the background is set correctly on load/initialization
  updateCarousel(currentIndex);
  startAutoplay();

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      resetAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoplay();
    });
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      updateCarousel(index);
      resetAutoplay();
    });
  });

  // Swipe functionality
  let touchStartX = 0;
  let touchEndX = 0;
  let touchStartY = 0;
  let touchEndY = 0;
  let isDragging = false;
  let hasSwiped = false;

  const handleDragStart = (e) => {
    isDragging = true;
    hasSwiped = false;
    touchStartX = e.type.includes('mouse') ? e.screenX : e.touches[0].screenX;
    touchStartY = e.type.includes('mouse') ? e.screenY : e.touches[0].screenY;
    stopAutoplay();
  };

  const handleDragEnd = (e) => {
    if (!isDragging) return;
    isDragging = false;
    touchEndX = e.type.includes('mouse') ? e.screenX : e.changedTouches[0].screenX;
    touchEndY = e.type.includes('mouse') ? e.screenY : e.changedTouches[0].screenY;
    
    const swipeThreshold = 50;
    const diffX = touchStartX - touchEndX;
    const diffY = touchStartY - touchEndY;

    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > swipeThreshold) {
      hasSwiped = true;
      if (diffX > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
    startAutoplay();
  };

  section.addEventListener('touchstart', handleDragStart, {passive: true});
  section.addEventListener('touchend', handleDragEnd, {passive: true});
  section.addEventListener('mousedown', handleDragStart);
  section.addEventListener('mouseup', handleDragEnd);
  
  // Pause on hover / handle mouse leaving the area
  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', () => {
    isDragging = false;
    startAutoplay();
  });

  // Prevent link click if the user was just swiping
  section.addEventListener('click', (e) => {
    if (hasSwiped) {
      e.preventDefault();
      e.stopPropagation();
      hasSwiped = false;
    }
  });

  // Prevent native drag behavior on images and links which interferes with mouse swiping
  section.querySelectorAll('img, a').forEach(el => {
    el.addEventListener('dragstart', (e) => e.preventDefault());
  });

  // Allow external triggers to change slide (e.g. Shopify Editor)
  section.addEventListener('change-slide', (e) => {
    updateCarousel(e.detail.index);
    resetAutoplay();
  });
}

function initAllDynamicHeroes() {
  document.querySelectorAll('.dynamic-hero-section').forEach(section => {
    initDynamicHeroSection(section);
  });
}

document.addEventListener('DOMContentLoaded', initAllDynamicHeroes);

// Shopify Theme Editor Integration
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.classList && event.target.classList.contains('dynamic-hero-section')
      ? event.target
      : event.target.querySelector('.dynamic-hero-section');

    if (section) {
      initDynamicHeroSection(section);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    const slide = event.target;
    if (slide.classList && slide.classList.contains('dynamic-hero__slide')) {
      const section = slide.closest('.dynamic-hero-section');
      if (section) {
        const index = parseInt(slide.getAttribute('data-index'), 10);
        if (!isNaN(index)) {
          section.dispatchEvent(new CustomEvent('change-slide', { detail: { index } }));
        }
      }
    }
  });
}
